/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplication extends models.AppSecopsApplicationBase {
    getFixupPrototypeFunction() { return AppSecopsApplication.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplication>): AppSecopsApplication {
        let obj = Object.assign(new AppSecopsApplication(), model);
        AppSecopsApplication.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplication>): AppSecopsApplication {
        if (!model) return null;
        return AppSecopsApplication.newInstance(<AppSecopsApplication> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplication) {
        if (!obj) return;

        models.AppSecopsApplication.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplication): boolean {
        if (models.AppSecopsApplicationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplication.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Application ID
     */
    application_id: string;

    /**
     * Application created time
     */
    created_at: Date;

    /**
     * Name of the user who created the application
     */
    created_by: string;

    /**
     * Name of the user who recently updated the application
     */
    updated_by: string;

    /**
     * Application recently updated time
     */
    updated_at: Date;

}
